function convertToMoney(amountToFormat){
    let ZARFormatter = new Intl.NumberFormat('en-ZA', {
        style: 'currency',
        currency: 'ZAR',
      });
    
      const formattedAmount = ZARFormatter.format(amountToFormat);
      return formattedAmount.replace(',','.');
}